import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  forwardRef,
  Input,
  OnInit,
  Output,
  SimpleChanges
} from '@angular/core';
import {
  AbstractControl,
  UntypedFormControl,
  UntypedFormGroup,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  ValidationErrors,
  Validators
} from "@angular/forms";
import {SharedService} from "../../../../shared/shared.service";
import {CoreService} from "../../../../../services/core/core.service";
import {DialogService} from "../../../../../services/core/dialog.service";
import {first, Subscription} from "rxjs";
import {pairwise, startWith} from "rxjs/operators";
import {HelperService} from "../../../../../services/helper.service";
import { NotOnlySpaces } from '../../../../shared/CustomValidators/CustomNotOnlySpacesValidator';
import { EmailValidator } from '../../../../shared/CustomValidators/CustomInvalidEmailValidator';
import {WebsiteURLValidator} from '../../../../shared/CustomValidators/CustomWebsiteUrlValidator';
import {PhoneNumberValidator} from '../../../../shared/CustomValidators/CustomInvalidPhoneNumberValidator';


@Component({
    selector: 'app-subcontractor-detail-form',
    templateUrl: './subcontractor-detail-form.component.html',
    styleUrls: ['./subcontractor-detail-form.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => SubcontractorDetailFormComponent),
            multi: true
        },
        {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => SubcontractorDetailFormComponent),
            multi: true
        }
    ],
    standalone: false
})
export class SubcontractorDetailFormComponent implements OnInit {

  @Input() model: any = {};
  @Input() form: any = {};
  @Input() isEdit: boolean = false;
  @Output() callback = new EventEmitter<any>(true);
  @Output() onInitForm = new EventEmitter<any>(true);
  urlPrefix = 'https://';
  //@ts-ignore
  public subcontractorDetailFormSubscription: Subscription;
  public states:any[] = [];
  panelOpenState = false;
  billing_address: any = '';
  shipping_address: any = '';
  billingAddressChangesFlag: boolean = false;
  shippingAddressChangesFlag: boolean = false;

  public subcontractorDetailForm: UntypedFormGroup = new UntypedFormGroup({

    tax_number: new UntypedFormControl(null,[]),
    fax: new UntypedFormControl(null,[PhoneNumberValidator()]),
    website: new UntypedFormControl(null,[WebsiteURLValidator()]),

    address: new UntypedFormControl(null),
    billing_address: new UntypedFormControl(null),
    shipping_address: new UntypedFormControl(null),
    misc_notes: new UntypedFormControl(null),
    specific_notes: new UntypedFormControl(null),
    has_vehicle: new UntypedFormControl(false),
    can_work_in_state: new UntypedFormControl(false),
    can_work_out_state: new UntypedFormControl(false),
    states: new UntypedFormControl(false)
  });

  constructor(
    public sharedService: SharedService,
    public coreService: CoreService,
    public dialogService: DialogService,
    private helperService: HelperService,
    private cd: ChangeDetectorRef,

  ) { }


  ngOnChanges(changes: SimpleChanges) {
    this.model = changes?.model?.currentValue;
  }

  prventspace(event :KeyboardEvent){
    if(event.keyCode === 32){
      event.preventDefault();
    }
  }

  ngOnInit(): void {
    this.getStates();
    this.initSubscriptions();
  }

  ngAfterViewInit(): void {
    this.setDataOnEdit();
  }

  setDataOnEdit = () => {
    if(this.isEdit) {
      this.subcontractorDetailForm?.setValue({
        tax_number: this.model?.tax_number,
        fax: this.model?.fax,
        website: this.model?.website,
        address: {
          address_line_1: this.model?.address_line_1,
          address_line_2: this.model?.address_line_2,
          city: this.model?.city,
          zipcode: this.model?.zipcode,
          state_id: this.model?.state,
        },
        billing_address: {
          address_line_1: this.model?.billing_address_line_1,
          address_line_2: this.model?.billing_address_line_2,
          city: this.model?.billing_city,
          zipcode: this.model?.billing_zipcode,
          state_id: this.model?.billing_state,
        },
        shipping_address: {
          address_line_1: this.model?.shipping_address_line_1,
          address_line_2: this.model?.shipping_address_line_2,
          city: this.model?.shipping_city,
          zipcode: this.model?.shipping_zipcode,
          state_id: this.model?.shipping_state,
        },
        misc_notes: this.model?.misc_notes,
        specific_notes: this.model?.specific_notes,
        has_vehicle : this.model?.has_vehicle,
        can_work_in_state : this.model?.can_work_in_state,
        can_work_out_state : this.model?.can_work_out_state,
        states: this.model?.states,
      });
    }
  }

  getStates = () => {
    return this.sharedService.getAllStates()
      .pipe(first())
      .subscribe(
        (data:any) => {
          this.states = data?.data?.map((state:any)=>{
            return {id: state?.id, name: state?.name};
          });
        });
  }

  public onTouched: () => void = () => {};

  writeValue(val: any): void {
    val && this.subcontractorDetailForm.setValue(val, { emitEvent: false });
  }

  registerOnChange(fn: any): void {
    this.subcontractorDetailForm.valueChanges.subscribe(fn);
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    isDisabled ? this.subcontractorDetailForm.disable() : this.subcontractorDetailForm.enable();
  }

  validate(c: AbstractControl): ValidationErrors | null{
    return this.subcontractorDetailForm.valid ? null : { invalidForm: {valid: false, message: "Subcontractor fields are invalid"}};
  }

  onBlurWebsiteUrl(){
    const url = this.helperService.removeHttp(this.subcontractorDetailForm.get('website')?.value)
    this.subcontractorDetailForm.get('website')?.setValue(url);
  }

  public changeAddressObject = (value:any) => {
    const obj = {
      address_line_1:value?.address_line_1,
      address_line_2:value?.address_line_2,
      city:value?.city,
      relations:{state:value?.state ? value?.state : value?.state_id},
      zipcode:value?.zipcode,
    }
    return obj;
  }

  copyAddressToBillingAddress(){
    this.billingAddressChangesFlag = true;
    const address = this.subcontractorDetailForm.get('address')?.value;
    this.billing_address = this.changeAddressObject(address);
    this.cd.detectChanges();
    this.billingAddressChangesFlag = false;
    // this.companyDetailForm.get('billing_address')?.setValue(address);
  }

  copyAddressToShippingAddress(){
    this.shippingAddressChangesFlag = true;
    const address = this.subcontractorDetailForm.get('address')?.value;
    this.shipping_address = this.changeAddressObject(address);
    this.cd.detectChanges();
    this.shippingAddressChangesFlag = false;
  }

  initChildForm( formControlName: string, value: any){
    this.subcontractorDetailForm.get(formControlName)?.setValue(value);
    // this.companyDetailForm.get('billing_address')?.setValue(value);
    this.onInitForm.emit(this.subcontractorDetailForm);
  }

  initSubscriptions(){
    console.log("This form is ",this.form);
    if (this.form){
      // @ts-ignore

      this.subcontractorDetailFormSubscription = this.form.valueChanges
        .pipe(startWith(null), pairwise())
        .subscribe(([prev, next]: [any, any]) => {

          if (this.form.touched){
            this.touchFormControls();
          }
        });
    }
    this.onInitForm.emit(this.subcontractorDetailForm);
  }

  touchFormControls(){
    Object.keys(this.subcontractorDetailForm.controls).forEach(key => {
      this.subcontractorDetailForm.get(key)?.markAsTouched();
    });
  }


  ngOnDestroy(){
    // prevent memory leak when component destroyed
    this.subcontractorDetailFormSubscription?.unsubscribe();
  }

}
